import {
  Network, Shovel, RadioTower, GitMerge, Repeat, Server, Move, Radio, ServerCog, HardHat, ArrowUpRight,
} from "lucide-react";
import { Reveal, SectionHead } from "@/components/Reveal";
import { scrollToId } from "@/lib/site";

const SERVICES = [
  { icon: Network, title: "Fiber Infrastructure", desc: "Design, supply and deployment support for optical fiber infrastructure." },
  { icon: Shovel, title: "Underground OFC Laying", desc: "Professional underground optical fiber cable laying, route preparation, trenching, ducting and associated civil works." },
  { icon: RadioTower, title: "Aerial OFC Laying", desc: "Aerial optical fiber deployment including cable installation, route preparation and supporting infrastructure." },
  { icon: GitMerge, title: "Fiber Splicing & Termination", desc: "Fiber splicing, termination, testing and fiber management solutions." },
  { icon: Repeat, title: "Fiber Lease / Rent", desc: "Optical fiber connectivity on lease or rental basis, structured around customer requirements." },
  { icon: Server, title: "Co-location", desc: "Infrastructure and space support for telecom and networking equipment." },
  { icon: Move, title: "Fiber Shifting / Relocation", desc: "Professional shifting and relocation of fiber infrastructure and telecom equipment." },
  { icon: Radio, title: "RF Links", desc: "RF connectivity and wireless link infrastructure support." },
  { icon: ServerCog, title: "Network Infrastructure", desc: "Deployment support for switches, routers, SFPs and other networking infrastructure." },
  { icon: HardHat, title: "Telecom Civil Works", desc: "Civil infrastructure works associated with telecom and optical fiber deployment." },
];

export default function Services() {
  return (
    <section id="services" data-testid="services-section" className="bg-white py-24 lg:py-32">
      <div className="mx-auto max-w-7xl px-5 lg:px-8">
        <SectionHead
          eyebrow="Telecom Infrastructure Services"
          title="Complete Telecom Infrastructure Solutions"
          sub="Ten focused service lines covering the full lifecycle of fiber and network infrastructure — from groundwork to live connectivity."
        />

        <div className="mt-14 grid grid-cols-1 gap-5 md:grid-cols-2 lg:grid-cols-3">
          {SERVICES.map((s, i) => (
            <Reveal key={s.title} delay={(i % 3) * 0.08}>
              <div
                data-testid={`service-card-${i + 1}`}
                onClick={() => scrollToId("contact")}
                className="group relative h-full cursor-pointer overflow-hidden rounded-2xl border border-slate-200 bg-white p-7 transition-all duration-300 hover:-translate-y-1.5 hover:border-blue-400/50 hover:shadow-2xl hover:shadow-blue-500/10"
              >
                <span className="pointer-events-none absolute -right-2 top-3 font-heading text-6xl font-extrabold text-slate-100 transition-colors duration-300 group-hover:text-blue-100">
                  {String(i + 1).padStart(2, "0")}
                </span>
                <span className="relative inline-flex rounded-xl bg-navy p-3 text-cyan-300 transition-colors duration-300 group-hover:bg-electric group-hover:text-white">
                  <s.icon size={20} />
                </span>
                <h3 className="relative mt-5 font-heading text-xl font-bold tracking-tight text-navy">
                  {s.title}
                </h3>
                <p className="relative mt-3 text-sm leading-relaxed text-slate-600">{s.desc}</p>
                <span className="relative mt-5 inline-flex items-center gap-1.5 text-xs font-semibold text-electric opacity-0 transition-all duration-300 group-hover:opacity-100">
                  Enquire about this service <ArrowUpRight size={13} />
                </span>
              </div>
            </Reveal>
          ))}
        </div>
      </div>
    </section>
  );
}
